import React, { useContext, useEffect, useState } from 'react';
import { AppSettings } from '../../config/app-settings';
import Loader from '../pages/loader';
import ReusableTable from '../../components/other/ReuseableTable';
import { useListPlatformsQuery } from '../../redux/Api/PlatformApiSlice';
import EditCreatePlatform from '../../components/platforms/EditCreatePlatform';
import { can } from '../../helpers/auth';
import NoPermission from '../pages/noPermission';
import { toast } from 'react-toastify';

function Platforms() {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10
    })

    const { data: platforms, isLoading, error, isFetching } = useListPlatformsQuery({
        expand: ['last_updated_by'].join(','),
        page: pagination.current,
        page_size: pagination.pageSize,
        ordering: '-id'
    });
    const [edit, setEdit] = useState(false)
    const [create, setCreate] = useState(false)
    const [holder, setHolder] = useState()


    const columns = [
        { title: "ID", dataIndex: "id", key: "id", sorter: true },
        {
            title: 'Platform Name',
            dataIndex: 'platform_name',
            key: 'platform_name',
            sorter: true,
            search: true,
        },

        {
            title: 'Platform Description',
            dataIndex: 'description',
            key: 'description',
            sorter: true,
            search: true,
        },
        {
            title: 'Last Updated By',
            dataIndex: 'last_updated_by',
            key: 'last_updated_by',
            render: (text, record) => {
                const { last_updated_by } = record;
                return last_updated_by ? `${last_updated_by.first_name} ${last_updated_by.last_name}` : '';
            },
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <div className='flex gap-2'>
                    <button className='btn btn-outline-theme' onClick={() => handleEdit(record)}>Edit</button>
                </div>
            ),
        },
    ];

    const handleEdit = (record) => {
        setHolder(record)
        setEdit(true)
    };

    const handleTableChange = paginationInfo => {
        setPagination({
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize
        })
    }

    const context = useContext(AppSettings);
    useEffect(() => {
        context.setAppHeaderNone(false);
        context.setAppSidebarNone(false);
        context.setAppContentClass('');
        context.setAppThemePanal(true)

        return function cleanUp() {
            context.setAppHeaderNone(true);
            context.setAppSidebarNone(true);
            context.setAppContentClass('p-0');
            context.setAppThemePanal(false)
        };
    }, []);

    useEffect(() => {
        if (error?.data) {
            const errorMessages = Object.values(error.data).flat()
            errorMessages.forEach(message => {
                toast.error(message)
            })
        }
    }, [error])

    if (!can("view_platform")) {
        return <NoPermission />
    }

    return (
        <div className='w-full flex flex-col'>
            <Loader isLoading={isLoading || isFetching} />
            {edit ? <EditCreatePlatform state={"edit"} open={edit} setOpen={setEdit} platform={holder} /> : null}
            {create ? <EditCreatePlatform state={"create"} open={create} setOpen={setCreate} platform={null} /> : null}
            <button className='btn btn-outline-theme ml-auto' onClick={() => setCreate(true)}>Add New Platform</button>
            <br />
            {platforms ? (
                <ReusableTable
                    columns={columns}
                    data={platforms?.results}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: platforms?.count,
                        showSizeChanger: true
                    }}
                    onChange={handleTableChange}
                />
            ) : null}
        </div>
    )
}

export default Platforms;
